export enum LanguageConst {
    FRENCH = "French", ARABIC = "Arabic",
    ENGLISH = "English"
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/resources/languageconst.ts